export const companyInfo = {
  name: "Key Vest Massilia",
  tagline: "Investir en immobilier, sans charge mentale",
  subtitle: "Investissement immobilier clé en main — de la recherche à la mise en location",
  phone: "06.95.82.42.48",
  email: "Keyinvestmassilia@gmail.com",
  address: "Marseille, France",
  description: "Key Vest Massilia vous accompagne dans votre investissement locatif clé en main à Marseille. De la recherche du bien à la mise en location, nous gérons tout pour vous.",
};

export const stats = [
  { value: "15+", label: "Projets réalisés", suffix: "" },
  { value: "7", label: "Rendement moyen", suffix: "%" },
  { value: "100", label: "Clients satisfaits", suffix: "%" },
  { value: "240", label: "Heures économisées", suffix: "h" },
];

export const services = [
  {
    step: "01",
    title: "Diagnostic & Stratégie",
    description: "Nous définissons ensemble votre stratégie d'investissement : budget, objectif patrimonial, cible locative. Un cadrage précis pour un projet sur-mesure.",
    icon: "Target",
  },
  {
    step: "02",
    title: "Recherche & Sélection",
    description: "Sourcing actif via agences, off-market et réseaux locaux. Pré-analyse de chaque bien : emplacement, copropriété, charges, risques et potentiel locatif.",
    icon: "Search",
  },
  {
    step: "03",
    title: "Conception & Budget Travaux",
    description: "Plans et moodboards réalisés par notre architecte d'intérieur. Devis détaillé et budget travaux maîtrisé dès le départ pour éviter les mauvaises surprises.",
    icon: "Ruler",
  },
  {
    step: "04",
    title: "Rénovation & Pilotage",
    description: "Suivi et coordination des travaux avec nos artisans professionnels. Reporting régulier (photos/vidéos) et garantie décennale sur tous les chantiers.",
    icon: "Hammer",
  },
  {
    step: "05",
    title: "Ameublement & Mise en Location",
    description: "Sélection du mobilier et de la déco selon la cible locative. Votre appartement est livré prêt à louer, clé en main.",
    icon: "Key",
  },
];

export const detailedSteps = [
  {
    step: 1,
    title: "Cadrage & Stratégie",
    items: [
      "Définir vos objectifs et votre stratégie",
      "Fixer votre budget (banque ou courtier)",
      "Valider le cahier des charges du projet",
    ],
  },
  {
    step: 2,
    title: "Recherche & Sélection",
    items: [
      "Sourcing actif : agences, off-market, réseaux locaux",
      "Pré-analyse de chaque bien : emplacement, copropriété, charges, risques",
      "Visites & compte-rendu : photos/vidéos, étude de rentabilité",
      "Rédaction et envoi de l'offre + suivi des échanges",
    ],
  },
  {
    step: 3,
    title: "Compromis",
    items: [
      "Analyse des documents : diagnostics, PV d'AG, règlement de copropriété",
      "Signature du compromis chez le notaire",
      "Lancement du dossier de prêt (banque / courtier)",
      "Début de conception des plans",
    ],
    payment: "1er acompte Key Vest Massilia",
  },
  {
    step: 4,
    title: "Acte Authentique",
    items: [
      "Accord bancaire & signature de l'acte",
      "Organisation du planning et du démarrage travaux",
      "Lancement du chantier avec nos partenaires",
    ],
    payment: "1er acompte travaux + 2ème acompte Key Vest",
  },
  {
    step: 5,
    title: "Chantier",
    items: [
      "Suivi et coordination des travaux",
      "Reporting régulier (photos/vidéos)",
      "Ajustements validés avec vous si nécessaire",
    ],
    payment: "2ème acompte travaux selon échéancier",
  },
  {
    step: 6,
    title: "Ameublement",
    items: [
      "Sélection mobilier/déco selon cible locative",
      "Commandes + livraison selon planning",
      "Montage et installation",
    ],
    payment: "1er acompte mobilier selon échéancier",
  },
  {
    step: 7,
    title: "Livraison",
    items: [
      "Réception du chantier + levée des réserves",
      "Finitions, mise en valeur, photos",
      "Bien prêt à être proposé à la location",
    ],
    note: "Gestion locative non incluse — partenaire recommandé",
  },
];

export const whyMarseille = [
  {
    title: "Une métropole dynamique",
    description: "Capitale économique du Sud, Marseille s'appuie sur un tissu solide : activités portuaires, santé, services, tourisme et pôles d'innovation.",
    icon: "Building2",
  },
  {
    title: "Demande locative forte",
    description: "Entre étudiants, jeunes actifs et familles, la demande est portée par plusieurs profils, limitant la dépendance à un seul type de locataire.",
    icon: "Users",
  },
  {
    title: "Marché encore accessible",
    description: "Comparée à d'autres grandes métropoles, Marseille offre un ticket d'entrée plus abordable tout en conservant une forte demande.",
    icon: "TrendingDown",
  },
  {
    title: "Rendement intéressant",
    description: "La rentabilité se joue sur la micro-localisation, l'optimisation des surfaces, la qualité de la rénovation et un budget maîtrisé.",
    icon: "TrendingUp",
  },
  {
    title: "Diversité de stratégies",
    description: "Meublé longue durée, colocation, location courte durée — Marseille permet d'adapter la stratégie à votre profil.",
    icon: "LayoutGrid",
  },
  {
    title: "Ville en transformation",
    description: "La rénovation de certains secteurs, l'amélioration des transports et la montée en gamme contribuent à un contexte favorable.",
    icon: "ArrowUpRight",
  },
];

export const realisations = [
  {
    id: 1,
    name: "Le Panier Doré",
    type: "T2",
    location: "Le Panier",
    rentabilite: "10%",
    surface: "42 m²",
    image: "https://images.unsplash.com/photo-1757439402190-99b73ac8e807?w=600&h=400&fit=crop",
    imageAfter: "https://images.unsplash.com/photo-1772797583328-f83bc3f94f80?w=600&h=400&fit=crop",
  },
  {
    id: 2,
    name: "Longchamp Élégance",
    type: "T3",
    location: "Longchamp",
    rentabilite: "7%",
    surface: "58 m²",
    image: "https://images.unsplash.com/photo-1759238136818-7b00ec9e782a?w=600&h=400&fit=crop",
    imageAfter: "https://images.unsplash.com/photo-1759735218086-67f9f853ab8b?w=600&h=400&fit=crop",
  },
  {
    id: 3,
    name: "La Joliette Moderne",
    type: "T2",
    location: "La Joliette",
    rentabilite: "6.5%",
    surface: "35 m²",
    image: "https://images.pexels.com/photos/36353404/pexels-photo-36353404.png?w=600&h=400&fit=crop",
    imageAfter: "https://images.pexels.com/photos/5691549/pexels-photo-5691549.jpeg?w=600&h=400&fit=crop",
  },
  {
    id: 4,
    name: "Vieux Port Charme",
    type: "T3",
    location: "Vieux Port",
    rentabilite: "5.8%",
    surface: "65 m²",
    image: "https://images.unsplash.com/photo-1690957530220-98bacb3c1163?w=600&h=400&fit=crop",
    imageAfter: "https://images.pexels.com/photos/35466643/pexels-photo-35466643.jpeg?w=600&h=400&fit=crop",
  },
  {
    id: 5,
    name: "Cinq Avenues Studio",
    type: "Studio",
    location: "Cinq Avenues",
    rentabilite: "8%",
    surface: "22 m²",
    image: "https://images.unsplash.com/photo-1772797583328-f83bc3f94f80?w=600&h=400&fit=crop",
    imageAfter: "https://images.unsplash.com/photo-1757439402190-99b73ac8e807?w=600&h=400&fit=crop",
  },
  {
    id: 6,
    name: "Réformés Duplex",
    type: "T4",
    location: "Les Réformés",
    rentabilite: "6%",
    surface: "78 m²",
    image: "https://images.unsplash.com/photo-1759735218086-67f9f853ab8b?w=600&h=400&fit=crop",
    imageAfter: "https://images.unsplash.com/photo-1759238136818-7b00ec9e782a?w=600&h=400&fit=crop",
  },
];

export const testimonials = [
  {
    name: "Sophie M.",
    text: "Key Vest Massilia a transformé notre projet d'investissement en réalité. Le suivi était impeccable du début à la fin. Notre T2 au Panier génère un rendement de 7,5% !",
    rating: 5,
    initial: "S",
  },
  {
    name: "Thomas L.",
    text: "Excellente expérience ! L'équipe a su trouver le bien idéal et la rénovation est au-dessus de nos attentes. Je recommande sans hésiter pour investir à Marseille.",
    rating: 5,
    initial: "T",
  },
  {
    name: "Marie & Pierre D.",
    text: "Nous avons investi à distance depuis Paris. Key Vest Massilia a tout géré avec professionnalisme et transparence. Les reportings réguliers nous ont rassurés tout au long du projet.",
    rating: 5,
    initial: "M",
  },
];

export const blogPosts = [
  {
    id: 1,
    title: "Investir à Marseille : les quartiers à fort potentiel en 2025",
    excerpt: "Découvrez les secteurs les plus prometteurs pour votre investissement locatif à Marseille.",
    date: "15 mars 2025",
    category: "Analyse de marché",
    image: "https://images.pexels.com/photos/36360447/pexels-photo-36360447.jpeg?w=600&h=400&fit=crop",
  },
  {
    id: 2,
    title: "Location meublée vs nue : quel régime choisir ?",
    excerpt: "Comparez les avantages fiscaux et la rentabilité de chaque régime pour optimiser votre investissement.",
    date: "2 mars 2025",
    category: "Fiscalité",
    image: "https://images.pexels.com/photos/6030953/pexels-photo-6030953.jpeg?w=600&h=400&fit=crop",
  },
  {
    id: 3,
    title: "Comment calculer la rentabilité réelle de votre investissement",
    excerpt: "Exemple concret avec un T2 à Marseille : tous les calculs détaillés pour y voir clair.",
    date: "18 février 2025",
    category: "Conseil",
    image: "https://images.unsplash.com/photo-1756302220296-18a9d20a6d5a?w=600&h=400&fit=crop",
  },
];

export const faqItems = [
  {
    question: "Quel est le budget minimum pour investir avec Key Vest Massilia ?",
    answer: "Le budget dépend de votre profil et de votre capacité d'emprunt. Nous travaillons avec vous pour définir une stratégie adaptée, que ce soit pour un studio à partir de 80 000€ ou un T3 à 200 000€ et plus. L'important est de bien cadrer le projet en amont.",
  },
  {
    question: "Combien de temps dure un projet complet ?",
    answer: "En moyenne, un projet complet (de la recherche à la mise en location) prend entre 4 et 8 mois, selon la complexité des travaux et les délais administratifs. La phase de recherche peut être rapide grâce à notre réseau local.",
  },
  {
    question: "Puis-je investir à distance depuis une autre ville ?",
    answer: "Absolument ! C'est même l'un de nos points forts. Nous gérons tout sur place avec un reporting régulier (photos, vidéos, comptes-rendus). Beaucoup de nos clients investissent depuis Paris ou d'autres villes.",
  },
  {
    question: "Les travaux sont-ils garantis ?",
    answer: "Oui, tous nos chantiers sont couverts par une garantie décennale. Nous travaillons avec des artisans professionnels sélectionnés et le budget est verrouillé dès le départ pour éviter les mauvaises surprises.",
  },
  {
    question: "Proposez-vous la gestion locative ?",
    answer: "La gestion locative n'est pas incluse dans notre accompagnement, mais nous pouvons vous recommander notre agence partenaire qui assure une gestion efficace et sereine de votre bien.",
  },
  {
    question: "Comment fonctionne le programme de parrainage ?",
    answer: "Si vous nous recommandez et qu'un projet est signé, nous vous reversons 5% de nos honoraires en remerciement. Un bon moyen de rentabiliser encore plus votre investissement !",
  },
];

export const heroImages = {
  main: "https://images.unsplash.com/photo-1757439402190-99b73ac8e807?w=1200&h=800&fit=crop",
  secondary: "https://images.unsplash.com/photo-1759238136818-7b00ec9e782a?w=800&h=600&fit=crop",
};

export const marseilleImage = "https://images.pexels.com/photos/36360447/pexels-photo-36360447.jpeg?w=1400&h=600&fit=crop";
